import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background: ${({ theme }) => theme.colors.dark};
  color: rgba(255, 255, 255, 0.7);
  padding: 3rem 2rem 2rem;
`;

export const FooterContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 2fr 1fr 1fr;
    gap: 3rem;
  }
`;

export const FooterBrand = styled.div`
  h3 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1.4rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 0.75rem;

    span {
      font-style: italic;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.accent};
    }
  }

  p {
    font-size: 0.88rem;
    line-height: 1.7;
    max-width: 320px;
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const FooterColumn = styled.div`
  h4 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 1rem;
  }
`;

export const FooterLink = styled.a`
  display: block;
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.5);
  padding: 0.3rem 0;
  transition: color ${({ theme }) => theme.transitions.default};

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const FooterBottom = styled.div`
  padding-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const FooterText = styled.p`
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.35);
`;

